<template>
	<div class="home-user">
		<div class="page-wrapper">
			<VContainer
				tag="header"
			>
				<VRow align-content="center">
					<VCol
						cols="12"
						md="6"
						lg="6"
						class="d-flex flex-column banner-left"
						:class="{
							'banner-left--gap': isSmAndDown
						}"
					>
						<VCardText
							:class="isSmAndDown ? 'text-center font-weight-bold align-self-center w-100' : 'align-self-start'"
							class="text-top-heading"
						>
							{{ $t(`views.homeUser.${userType}.bannerLabel`) }}
						</VCardText>
						<VCardTitle
							tag="h1"
							:class="isSmAndDown ? 'text-h5 line-height-normal text-center' : 'text-h4'"
						>
							{{ $t(`views.homeUser.${userType}.title`) }}
						</VCardTitle>
						<VCardText
							tag="p"
							:class="isSmAndDown ? 'text-body-1 text-center' : 'text-body-1'"
						>
							{{ $t('views.homeUser.common.banner.subText') }}
						</VCardText>
					</VCol>
					<VCol
						cols="12"
						md="6"
						lg="6"
						class="d-flex flex-column align-end banner-right"
					>
						<ConnexionMCE :user-type="userType" />
					</VCol>
				</VRow>
				<VRow
					class="ma-16"
					justify="center"
				>
					<VCol
						md="8"
						cols="12"
					>
						<VCard
							flat
							class="pa-4"
						>
							<div class="d-flex align-start mb-3">
								<VCardTitle class="font-weight-regular line-height-normal pa-0">
									{{ $t('views.homeUser.employeur.informations.title') }}
								</VCardTitle>
							</div>
							<VCardText class="text-body-1 py-0">
								<div class="mb-4">
									<strong>{{ $t('views.homeUser.employeur.informations.first.firstPart') }}</strong> :
									{{ $t('views.homeUser.employeur.informations.first.secondPart') }} <strong>{{ $t('views.homeUser.employeur.informations.first.thirdPart') }}</strong>
								</div>
								<div>
									<strong>{{ $t('views.homeUser.employeur.informations.second.firstPart') }}</strong> :
									{{ $t('views.homeUser.employeur.informations.second.secondPart') }}
								</div>
							</VCardText>
						</VCard>
					</Vcol>
				</VRow>
			</VContainer>
			<VContainer tag="main">
				<VCard
					flat
					class="d-flex flex-column align-center"
					color="transparent"
				>
					<VRow
						align="center"
						justify="center"
					>
						<VCardTitle
							class="text-center mb-8"
							tag="h2"
							:class="isSmAndDown ? 'text-h5' : 'text-h4'"
						>
							{{ $t('views.homeUser.common.howItWorks.title') }}
						</VCardTitle>
						<VCardText
							tag="p"
							class="text-center text-body-1 white-space-pre-line px-sm-16 px-0"
						>
							Ce questionnaire permet de fournir à votre caisse primaire d'assurance maladie, l'ensemble des éléments nécessaires à l'étude du dossier de votre salarié
						</VCardText>
						<VAlert
							variant="tonal"
							type="info"
							outlined
							class="pa-3 info-box"
						>
							Les délais à respecter sont précisés dans le questionnaire accessible depuis votre compte
						</VAlert>
					</VRow>

					<VRow
						align="center"
						justify="center"
						class="ma-8"
					>
						<VCol>
							<iframe
								width="560"
								height="315"
								src="https://www.youtube.com/embed/nyJUnw5OiA0?si=2FYgWcF1m3Ij121q&amp;start=0"
								title="Le Questionnaire Risques Professionnels"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								referrerpolicy="strict-origin-when-cross-origin"
								allowfullscreen
							/>
						</VCol>
					</VRow>
					<HowItWorkProcess
						:text1="$t('views.homeUser.employeur.icons.signup')"
						:text2="$t('views.homeUser.common.icons.answer')"
						:text3="$t('views.homeUser.employeur.icons.folder')"
						:text4="$t('views.homeUser.common.icons.comment')"
						:text5="$t('views.homeUser.common.icons.decision')"
					/>
				</VCard>
			</VContainer>
			<VContainer
				tag="section"
				class="my-10"
			>
				<VRow justify="center">
					<VCol
						cols="12"
						md="6"
					>
						<VCard
							flat
							color="#E7ECF5"
							class="pa-5"
						>
							<VCardTitle>
								<img
									src="../assets/aide.svg"
									alt="Aide"
									class="mr-2"
								>
								<span>{{ $t('views.homeUser.common.help.title') }}</span>
							</VCardTitle>

							<VCardText class="help-info">
								<VIcon
									size="20px"
									class="mr-2"
								>
									{{ pcIcon }}
								</VIcon>
								<span>
									{{ $t('views.homeUser.common.help.moreInformation') }}
									<a
										target="_blank"
										href="https://www.ameli.fr/entreprise/vos-salaries"
									>
										ameli.fr
									</a>
								</span>
								<VIcon
									size="15px"
									class="ml-2"
								>
									{{ extLinkIcon }}
								</VIcon>
							</VCardText>
							<VCardText class="help-info">
								<VIcon
									size="20px"
									class="mr-2"
								>
									{{ telIcon }}
								</VIcon>
								<span>{{ $t('views.homeUser.common.help.phone') }} 3679</span>
							</VCardText>
						</VCard>
					</VCol>
				</VRow>
			</VContainer>
		</div>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { mapState } from 'vuex';
	import { mdiLaptop, mdiPhone, mdiOpenInNew } from '@mdi/js';
	import ConnexionMCE from '@/components/Authentification/ConnexionMCE.vue';
	import HowItWorkProcess from '@/components/Home/HowItWorkProcess.vue';

	const Props = Vue.extend({
		props: {
			userType: {
				type: String,
				required: true
			}
		}
	});

	const MixinsDeclaration = mixins(Props);

	@Component<HomeMce>({
		computed: mapState('appState', ['user']),
		components: {
			HowItWorkProcess,
			ConnexionMCE
		}
	})
	export default class HomeMce extends MixinsDeclaration {
		pcIcon = mdiLaptop;
		extLinkIcon = mdiOpenInNew;
		telIcon = mdiPhone;

		get isSmAndDown(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}
	}
</script>

<style scoped lang="scss">

/******************
	OVERRIDES
*******************/

:deep(.v-card__title) {
	padding: 0 0.5rem 0 0;
	font-weight: bold;
	line-height: normal;
	color: #0C419A;
	word-break: break-word;
}

:deep(.v-card__text) {
	padding: 0;
}

:deep(.v-card) {
	border: solid 1px #6D8DC2;
	background-color: #E7ECF5;
}

:deep(a) {
	text-transform: none;
	letter-spacing: normal;
}

/******************
      CLASSES
*******************/

.home-user {
	height: 100%;
	display: flex;
	gap: 2rem;
	justify-content: center;
	padding-top: 5rem;
	background: linear-gradient(#EFF1FC, #fff);
}

.page-wrapper {
	max-width: 1240px;
	display: flex;
	justify-content: center;
	align-content: center;
	flex-direction: column;
}

.text-top-heading {
	background-color: #0C419A;
	color: #fff;
	padding: 0.5rem;
	font-size: 1rem;
	font-weight: 500;
	width: auto;
}

.banner-left {
	gap: 0.5rem;

	&--gap {
		gap: 1rem;
	}
}

.banner-right {
	justify-content: center;
}

.help-info {
	display: flex;
	align-items: center;
	margin: 1rem 0;
	font-weight: 500;

	span {
		color: #0C419A;
	}
}
</style>
